// sign in
export const LOGIN = "auth/LOGIN";
export const LOGIN_SUCCESS = "auth/LOGIN_SUCCESS";
export const LOGIN_FAILURE = "auth/LOGIN_FAILURE";

export const LOGOUT = "auth/LOGOUT";

// Send reset password email
export const SEND_RESET_PASSWORD_EMAIL = "auth/SEND_RESET_PASSWORD_EMAIL";

// Confirm password reset
export const CONFIRM_PASSWORD_RESET = "auth/CONFIRM_PASSWORD_RESET";

// GET CURRENT USER
export const GET_CURRENT_USER = "auth/GET_CURRENT_USER";

//
export const CLEAR_ERROR = "auth/CLEAR_ERROR";

export const VERIFY_AUTH = "auth/VERIFY_AUTH";
export const VERIFY_AUTH_SUCCESS = "auth/VERIFY_AUTH_SUCCESS";
export const VERIFY_AUTH_FAILURE = "auth/VERIFY_AUTH_FAILURE";
export const SET_LAST_IDLE = "auth/SET_LAST_IDLE";
